import { SIZE_50 } from '@/lib/gridElements/size';

import { BubbleMapChart } from '@/components/composite/Charts/BubbleMapChart';

export const citiesDistributionConfig = {
    height: 300,
    name: {
        city: 'chart.tiktok.cities_distribution_city',
        value: 'chart.tiktok.cities_distribution_value',
        lat: 'chart.tiktok.cities_distribution_lat',
        lng: 'chart.tiktok.cities_distribution_lng',
        percentage: 'percentage'
    },
    tooltip: 'chart.tiktok.cities_distribution_tooltip',
    noLegend: true,
    datePickerDoesNotApply: true,
    id: 'cities_distribution',
    size: SIZE_50,
    type: 'chart',
    element: BubbleMapChart,
    defaultFilter: 'global',
    defaultTableSorting: [{ id: 'value', desc: true }],
    filters: {
        global: {
            title: 'chart.tiktok.cities_distribution_followers',
            menu: 'chart.tiktok.cities_distribution_filter_followers'
        },
        reach: {
            title: 'chart.tiktok.cities_distribution_reach',
            menu: 'chart.tiktok.cities_distribution_filter_reach'
        }
    },
    new: {
        dateAdded: '2025-08-06'
    }
};
